import ax from './customAxios';

const gestionDocumentosProvider = {
    obtenerArchivosTreeView: async() => {
        return await ax.get('/gestiondocumentos/ObtenerArchivosTreeView');
    },
    ObtenerAprobadores: async() => {
        return await ax.get('/gestiondocumentos/ObtenerAprobadores');
    },
    ObtenerArchivosPorId: async(body) => {
        return await ax.post('/gestiondocumentos/ObtenerArchivosPorId', body);
    },
    EliminarArchivosPorId: async(body) => {
        return await ax.post('/gestiondocumentos/EliminarArchivosPorId', body);
    },
    Registrar_Actualizar_Archivo: async(body) => {

        return await ax.post('/gestiondocumentos/Registrar_Actualizar_Archivo', body);
    },
    Actualizar_Directorio: async(body) => {

        return await ax.post('/gestiondocumentos/Actualizar_Directorio', body);
    },
    obtenerAdjuntoModel: async(data) => {
        return await ax.post('/gestiondocumentos/ObtenerModeloDocumentoAdjuntoPorId', data);
    },
    obtenerAdjunto: async(id) => {
        return await ax.get('/gestiondocumentos/ObtenerAdjunto/' + id, {
            responseType: 'blob'
        });
    },
    ListarArchivoPaginado: async(paginacion) => {
        return await ax.post('/gestiondocumentos/ListarArchivoPaginado', paginacion);
    },
    ListarHistorialArchivoPaginado: async(paginacion) => {
        return await ax.post('/gestiondocumentos/ListarHistorialArchivoPaginado', paginacion);
    },
    AprobacionFinal: async(body) => {
        return await ax.post('/gestiondocumentos/AprobacionFinal', body);
    },
    AsignarAprobador: async(body) => {
        return await ax.post('/gestiondocumentos/AsignarAprobador', body);
    },




};
export default gestionDocumentosProvider;